import { Attributes, DateUtils, Misc, Model, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class AuditTrailUserCriteria extends Model.CriteriaBase {

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date = DateUtils.today();

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<AuditTrailUserCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Audit Trail User Criteria";
    }
}